<button mat-raised-button (click)="goToList()" data-back-button>
  <mat-icon>arrow_back</mat-icon>Back
</button>
<mat-card appearance="raised" class="basecard">
  @if (!formMode) {
    <mat-card-header>
        <div style="width: calc(100% - 32px)">
            <div style="display: flex; width:100%; margin-bottom : 20px">
                <div style="width: 52px">
                    <app-avatar [id]="focusItem?.authorId"></app-avatar>
                </div>
                <div style="flex-grow: 1">
                    <h1 style="margin-bottom: 0px" data-post-title>{{pageForm.controls.title.value}}</h1>
                    <mat-card-subtitle style="margin-top: 2px;">
                        <div style="max-width: 20em">
                            <app-form-pill on="grid" [control]="$any(channelField.control)"></app-form-pill>
                        </div>
                        {{focusItem?.createdAt | fromNow }}
                        @if (focusItem?.updatedAt) {
                          <span>(Updated {{focusItem?.updatedAt | fromNow}})</span>
                        }
                      </mat-card-subtitle>
                </div>
                @if (!screenSvc.isPhone()) {
                    <div style="max-width:70px">
                        @if (canEditPost() && focusItem?.mailsSent >= 0) {
                            <button (click)="onEdit()" style="width: 4em" data-edit-button
                              mat-raised-button color="primary" matTooltip="Click to edit this post">
                              Edit
                            </button>
                          }
                    </div>
                    <div style="max-width:112px">
                          @if (canNotify()) {
                            <button style="width: 8em"
                              (click)="notifyUsers()"
                              mat-raised-button color="primary" data-notify-button
                              matTooltip="Click here to send a notification email to all users about your post">
                              Notify Users
                            </button>
                          }
                          @if (focusItem?.mailsSent < 0) {
                            <button disabled="true"  data-notify-button
                              mat-raised-button color="primary">
                              Sending Notifications...
                            </button>
                          }
                          @if (focusItem?.mailsSent > 0) {
                            <div matTooltip="{{focusItem?.mailsSent}} notifications where sent {{focusItem?.notificationSentAt | fromNow}}, {{focusItem?.notificationSentAt * 1000 | date}}">
                                <button disabled="true"  data-notify-button
                                mat-raised-button color="primary">
                                Notifications sent
                              </button>
                            </div>
                          }
                    </div>
                    <div style="max-width:70px">
                        @if (canDeletePost()) {
                            <button (click)="deleteObject()" mat-raised-button color="warn"
                            style="width: 6em; margin-left: 10px"  data-delete-button
                                matTooltip="Click to delete this post">
                                Delete
                            </button>
                        }
                    </div>
                }
            </div>
        </div>
    </mat-card-header>
  }
  @if (!formMode) {
    <mat-card-content>
      <div class="contentHolder">
        <div class="content">
            <div class="post-content" [innerHTML]="pageForm.controls.body.value"></div>
        </div>
      </div>
    </mat-card-content>
  }
  @if (formMode) {
    <mat-card-content>     
      <div class="contentHolder">
        <div class="content">
            <div class="formWidth">
                <app-form-picklist [control]="forumControl"></app-form-picklist>
            </div>          
            <div class="formWidth" style="display:flex; flex-wrap: wrap;">
              @if (this.areas.length > 0) {
                <div style="flex: 1; padding: 2px"><app-form-picklist [control]="areaControl"></app-form-picklist></div>
                <div style="flex: 1; padding: 2px"><app-form-picklist [control]="coreControl"></app-form-picklist></div>
              }
              <div style="flex: 1; padding: 2px"><app-form-picklist [control]="typeControl"></app-form-picklist></div>
              <div style="flex: 1; padding: 2px"><app-form-picklist [control]="categoryControl"></app-form-picklist></div>
            </div>

            <div class="formWidth">
                <mat-form-field>
                    <mat-label i18n>Post Title</mat-label>
                    <input matInput [formControl]="titleControl" id="title-textField">
                    <mat-error>
                        <app-form-error [control]="titleControl"></app-form-error>
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="formWidth">
                <editor [init]="editorOptions" [formControl]="bodyControl" [attr.data-id]="'content-RichTextField'"
                placeholder="Tell us more about what you would like to discuss" tinyMatFormControl>
                </editor>
                <mat-error>
                <app-form-error [control]="bodyControl"></app-form-error>
                </mat-error>
            </div>

          <!-- app-form-actions [(pageForm)]="pageForm" (cancel)="cancelChanges()" (save)="saveChanges()"></app-form-actions -->
          <app-form-actions [pageForm]="pageForm" (cancelChgs)="cancelChanges()" (save)="saveChanges()"
            (delete)="deleteObject()" [hideSaveAndNew]="true" [readonly]="false" [allowDelete]="false">
          </app-form-actions>
        </div>
      </div>
    </mat-card-content>
  }
  @if (!formMode) {
    <mat-card-footer>
    <!--app-comments *ngIf="focusItem" [post]="focusItem"></app-comments-->
    <!-- app-chat [control]="chatControl"></app-chat -->
     <div style="margin-top: 20px; padding-left:45px; padding-right: 20px; margin-left: 30px; max-width: 400px">
        <app-ctl-holder [control]="attachmentControl"></app-ctl-holder>
     </div>


    <div style="width:calc(100% - 70px); margin: 20px 20px 20px 50px">
      <app-ctl-holder [control]="chatControl"></app-ctl-holder>
    </div>
  </mat-card-footer>
}
</mat-card>
